/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Ticketpagecheckedinat4Inputs */

const en_ticketpagecheckedinat4 = /** @type {(inputs: Ticketpagecheckedinat4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked in: ${i?.time}`)
};

const de_ticketpagecheckedinat4 = /** @type {(inputs: Ticketpagecheckedinat4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eingecheckt: ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Checked in: {time}" |
*
* @param {Ticketpagecheckedinat4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecheckedinat4 = /** @type {((inputs: Ticketpagecheckedinat4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecheckedinat4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecheckedinat4(inputs)
	return de_ticketpagecheckedinat4(inputs)
});
export { ticketpagecheckedinat4 as "ticketPageCheckedInAt" }